import { call, put, select, takeEvery } from "redux-saga/effects";

import { IntegrationBusinessAction } from "actions";
import {
  ActivateIntegrationAction,
  CheckXeroActiveAction,
  ConnectIntegrationAction,
  IntegrationCredentialAction,
  XeroActionProps,
} from "actions/integrationCredentials";
import { XeroTrackingCategoryAction } from "actions/xeroTrackingCategories";

import { INTEGRATION_CREDENTIAL } from "constants/actionTypes";

import {
  getSettingsRoute,
  openActivateIntegrationCredential,
} from "lib/navigation";
import toast from "lib/toast";

import { getActiveRole } from "selectors";
import { getIntegrationCredentialById } from "selectors/integrationCredentials";

import history from "appHistory";

export function* checkIntegrationActive(
  integrationCredentialId: string,
  nextFunction: CheckXeroActiveAction["nextFunction"],
  props: XeroActionProps,
): Generator {
  const state: State = (yield select()) as State;
  const integrationCredential = getIntegrationCredentialById(
    integrationCredentialId,
  )(state);

  if (integrationCredential?.isEnabled) {
    yield put(nextFunction(props));
  } else {
    toast.error("Xero Integration Not Activated", {}, "INTEGRATIONS", () =>
      history.push(getSettingsRoute("Integrations")),
    );
  }
}

function* connectIntegration(action: ConnectIntegrationAction): Generator {
  if (action.options.redirectToActivate) {
    yield put(IntegrationCredentialAction.activate(action.payload.id));
  }
}

function* sendToActivate(action: ActivateIntegrationAction): Generator {
  const { slug } = getActiveRole((yield select()) as State);
  openActivateIntegrationCredential(action.id, slug);
}

export function* checkXeroActive(action: CheckXeroActiveAction): Generator {
  const { props, nextFunction } = action;
  yield call(
    checkIntegrationActive,
    props.integrationCredentialId ?? props.id,
    nextFunction,
    props,
  );
}

function* onCredentialsRefreshed(): Generator {
  yield put(IntegrationBusinessAction.request());
  yield put(XeroTrackingCategoryAction.request());
}

export default function* rootSaga(): Generator {
  yield takeEvery(INTEGRATION_CREDENTIAL.CREATE.SUCCESS, connectIntegration);
  yield takeEvery(INTEGRATION_CREDENTIAL.ACTIVATE.REQUEST, sendToActivate);
  yield takeEvery(INTEGRATION_CREDENTIAL.SYNCHRONIZE.ACTION, checkXeroActive);
  yield takeEvery(
    INTEGRATION_CREDENTIAL.PUSH_LEDGER_ACCOUNTS.ACTION,
    checkXeroActive,
  );
  yield takeEvery(
    INTEGRATION_CREDENTIAL.SYNC_DOCUMENTS.ACTION,
    checkXeroActive,
  );
  yield takeEvery(
    INTEGRATION_CREDENTIAL.CREATE_BUSINESS.ACTION,
    checkXeroActive,
  );
  yield takeEvery(
    INTEGRATION_CREDENTIAL.SYNCHRONIZE.SUCCESS,
    onCredentialsRefreshed,
  );
}
